import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../../shared/ui/PageHeader';
import { PermissionMatrix } from '../../users/components/PermissionMatrix';

export function SettingsPermissionsPage() {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader title={t('settings.permissions.title')} />
      <PermissionMatrix />
    </>
  );
}
